var App = App || {};

App.Alerts = (function ($) {
    'use strict';

    function Init() {
        var alerts = $("#Alerts").find(".alert");
        var modalAlerts = $(document).find(".alert-item");


        alerts.each(function (index, alert) {
            var $alert = $(alert),
                $alertCollapse = $alert.find(".btn-collapse"),
                guid = $alert.data("guid"),
                cookieName = `atomiccu_Alert_${guid}`,
                id = `#${guid}-Alert`;

            $alertCollapse.on("click", function () {
                var $collapseButton = $(this);

                ToggleCollapse($alert, $collapseButton, cookieName);
            });

            $alert.on("closed.bs.alert", function () {
                App.Cookies.setItem(cookieName, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            })

        });

        modalAlerts.each(function (index, alert) {
            var $alert = $(alert),
                guid = $alert.data("guid"),
                cookieName = `atomiccu_Alert_${guid}`,
                id = `#alert-${guid}`;

            if ($alert.hasClass("modal")) {

                const alertModal = document.querySelector(id)

                const configObject = { keyboard: false }
                const modalAlert = new bootstrap.Modal(alertModal, configObject)

                $alert.on("hide.bs.modal", function () {
                    App.Cookies.setItem(cookieName, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
                })

                if (App.Cookies.getItem(cookieName) != "Dismissed") {
                    modalAlert.show();
                }
            }


        });
    }

    function ToggleCollapse($alert, $collapseButton, cookieName) {
        if ($collapseButton.attr("aria-expanded") == "false") {
            $collapseButton.attr("aria-expanded", "true");

            $alert
                .removeClass("collapsed")
                .attr("role", "alert");

            App.Cookies.setItem(cookieName, "Collapsable", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
        else {
            $collapseButton.attr("aria-expanded", "false");

            $alert
                .addClass("collapsed")
                .attr("role", null);

            App.Cookies.setItem(cookieName, "Collapsed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
    }

    return {
        Init: Init
    };

})(jQuery);
